// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"239":"57913da0","448":"57913da0"}[chunkId] + ".chunk.css";
};